module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/20ce1e1c6c52ac50d85a51336b714b29.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/goldBar.svg
// module id = 2atI
// module chunks = 1